const SEPARATOR = ' - ';

// O cadastro guarda "CCO - Flow80"; no seletor o operador procura o flow, e
// o grupo na frente só alonga cada linha. Fica o que vem depois do último
// " - "; nome sem separador, ou sem nada depois dele, fica inteiro.
export function clusterShortName(name: string): string {
  const trimmed = name.trim();
  const i = trimmed.lastIndexOf(SEPARATOR);
  if (i < 0) return trimmed;
  const tail = trimmed.slice(i + SEPARATOR.length).trim();
  return tail.length > 0 ? tail : trimmed;
}
